import { render } from "./TopbarSaleEn.vue?vue&type=template&id=10a984bc"
import script from "./TopbarSaleEn.vue?vue&type=script&lang=js"
export * from "./TopbarSaleEn.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\marco\\Desktop\\archeo-guida-smart\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__